import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import axios from "axios";
import BidsTable from "../BidsTable";
import ItemCount from "../../../utils/ItemCount";
import RFQTable from "../RFQTable";
import AllRFQBidTable from "../AllRFQBidTable";

const PurchaseHeadDashboard = () => {
  const [rfqs, setRfqs] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "PROGRESS"
  );
  const [isLoading, setIsLoading] = useState(true);
  const [bidCount, setBidCount] = useState(0);
  const [rfqBidCount, setRfqBidCount] = useState();
  const [progressCount, setProgressCount] = useState();
  const [concludedCount, setConcludedCount] = useState();
  useEffect(() => {
    const getProgressCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count-all-bid?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setProgressCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getProgressCount();

    const getConcludedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/rfq/count?username=${storedUser.username}&status=CONCLUDED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setConcludedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getConcludedCount();
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBidCount();
    const getRFQBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count-bid?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRfqBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getRFQBidCount();
  }, []);

  useEffect(() => {
    if (activeTab === "QUOTES") {
      const getQuotes = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq-by-bid-status?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getQuotes();
    } else if (activeTab === "PROGRESS") {
      const getAllRFQByBid = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq-by-all-status?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getAllRFQByBid();
    } else if (activeTab === "CONCLUDED") {
      const getRFQs = async () => {
        setRfqs();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/rfq?username=${storedUser.username}&status=CONCLUDED`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getRFQs();
    } else {
      const getBids = async () => {
        setRfqs();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
          localStorage.removeItem("activeTab");
        } catch (error) {
          console.log(error);
        }
      };
      getBids();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("BIDS");
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "PROGRESS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PROGRESS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "PROGRESS");
              }}
            >
              In Quotes
              <ItemCount count={progressCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "BIDS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("BIDS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "BIDS");
              }}
            >
              Action Required
              <ItemCount count={bidCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "QUOTES" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUOTES");
                setIsLoading(true);
                localStorage.setItem("activeTab", "QUOTES");
              }}
            >
              In Recommendation
              <ItemCount count={rfqBidCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "CONCLUDED" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("CONCLUDED");
                setIsLoading(true);
                localStorage.setItem("activeTab", "CONCLUDED");
              }}
            >
              Concluded
              <ItemCount count={concludedCount} />
            </Button>
          </Box>
          {/* <Box>
            <Button
              className="pending-btn"
              onClick={() => {
                navigate("/dashboard/pending-actions")
                setActiveTab("EMD");
              }}
            >
              My Pending actions
            </Button>
          </Box> */}
        </Box>
        {activeTab === "QUOTES" || activeTab === "CONCLUDED" ? (
          <RFQTable rfqs={rfqs} activeTab={activeTab} isLoading={isLoading} />
        ) : activeTab === "PROGRESS" ? (
          <AllRFQBidTable
            rfqs={rfqs}
            activeTab={activeTab}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        ) : (
          <BidsTable
            rfqs={rfqs}
            activeTab={activeTab}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        )}
      </Box>
    </Box>
  );
};

export default PurchaseHeadDashboard;
